module.exports = __webpack_public_path__ + "img/maslahat-1.b02356e5.png";